module.exports = __webpack_public_path__ + "0fd4a03cc607e98ecb9684079d14b0d4.jpg";